export default "__VITE_ASSET__CeWLG__H__"